import { groq } from 'next-sanity';
import { z } from 'zod';

import { SanityBasicText } from './basicText';
import { media, SanityMedia } from './media';
import { richText } from './richText';

export const SanityRichAccordion = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('richAccordion'),
  _key: z.string(),
  overline: z.string().optional().nullable(),
  headline: z.string(),
  media: SanityMedia.optional().nullable(),
  background: z.literal('#F4F4F5'),
  items: z.array(
    z.object({
      _key: z.string(),
      title: z.string(),
      content: SanityBasicText,
    }),
  ),
});
export type SanityRichAccordion = z.infer<typeof SanityRichAccordion>;

export const richAccordion = groq`{
  overline,
  headline,
  'background': '#F4F4F5',
  media[0] ${media},
  items[] {
    _key,
    title,
    content[] ${richText},
  }
}`;
